export const ContactIntents = {
    SCHEDULE_FOLLOW_UP: "Schedule Follow-up",
    INSURANCE_VERIFICATION: "Insurance Verification",
    TREATMENT_UPDATE: "Treatment Update",
    MISSED_APPOINTMENT: "Missed Appointment",
    PROGRESS_REVIEW: "Progress Review",
    AUTHORIZATION_STATUS: "Authorization Status",
    SCHEDULE_CHANGE: "Schedule Change",
    INITIAL_CONSULTATION: "Initial Consultation",
    DISCHARGE_PLANNING: "Discharge Planning",
    GENERAL_INQUIRY: "General Inquiry"
};
